import _ from 'lodash'
import PQueue from '../vendor/p-queue'
import * as API from '../api'
import Config from '../configs'
import queryString from 'query-string'

// load content group queue
const load_content_group_queue = new PQueue({ concurrency: 3 })

export default function fetchContentGroupsData() {
  const content_group_codes = Config.get('CONTENT_GROUPS')

  let content_groups = []
  let product_group_titles_hash = {}
  let product_group_codes = []

  const content_group_fetches = _.map(content_group_codes, content_group_code => {
    return () => API.fetchContentGroup(content_group_code).then(res => {
      const { data = {} } = res
      const { content_group = {} } = data
      const { content_group_lines = [] } = content_group
      let new_product_group_titles_hash = {}


      _.map(content_group_lines, (product_group, index) => {
        const { name = '', url = '' } = product_group
        const params = url.indexOf('?') !== -1 ? queryString.parse(url.split('?')[1]) : {}
        const product_group_code = _.get(params, 'hot_item_code') || _.get(params, 'category_2') || _.get(params, 'exclusive_code') || ''

        new_product_group_titles_hash[product_group_code.toLowerCase()] = name
        if (_.includes(['hot_items', 'exclusive_items'], content_group_code)) { product_group_codes.push(product_group_code) }
      })

      content_groups = _.concat(content_groups, content_group)
      product_group_titles_hash = _.merge(new_product_group_titles_hash, product_group_titles_hash)
    }).catch(err => {
      console.log(err)
      // const errors = API.handleError(err)
      // this.setState({ alert_message: errors.error_message }, () => this._flash.open())
    })
  })

  load_content_group_queue.addAll(content_group_fetches)

  return load_content_group_queue.onIdle().then(() => {
    return {
      content_groups,
      product_group_titles_hash,
      hot_item_codes: product_group_codes
    }
  })

}



// WEBPACK FOOTER //
// ./src/lib/fetchContentGroupsData.js